import styled from '@emotion/styled';
import { COLORS, MAIN_CONTENT_SIZE } from '../../constants';

export const StyledMainContentHeaderWrapper = styled.div<{ showShadow?: boolean }>`
  ${({ showShadow }) => showShadow && 'box-shadow: 0 2px 9px 0 rgb(0 0 0 / 20%);'}
  background-color: #3f3f3f;
`;

export const StyledMainContentHeader = styled.div`
  display: flex;
  @media (max-width: 1325px) {
    justify-content: center;
  }
  position: relative;
  height: 76px;
  max-width: ${MAIN_CONTENT_SIZE.S[0]}px;
  margin: 0 auto;

  @media (max-width: 1366px) {
    max-width: ${MAIN_CONTENT_SIZE.S[0]}px;
  }

  @media (min-width: 2046px) {
    max-width: ${MAIN_CONTENT_SIZE.L[0]}px;
  }
`;

export const StyledMainContentTitle = styled.div<{
  bgColor: string;
}>`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0.32px;
  line-height: 1;
  color: ${COLORS.blackOlive};

  position: absolute !important;
  right: 0;
  padding: 17px 14px;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 0 0 8px 8px;
`;
